module.exports = __webpack_public_path__ + "img/polish-hearts.4e521a0.svg";